// extracted by mini-css-extract-plugin
export default {"title":"WebExhibitView_title__XZ5tj","description":"WebExhibitView_description__-j12A"};